// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","one":"Footer_one__1O_qA","two":"Footer_two__1oJJZ","three":"Footer_three__3Y_Cs","child":"Footer_child__1oHXr","icon":"Footer_icon__ISVxC"};